import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { A, NoTranslate, DataTable, H1 } from '@contently/toolkit';
import { get } from '../../utils/api';

const ContentPortals = props => {
  const { appData } = props;
  const { brandProfileId } = JSON.parse(appData);
  const [data, setData] = useState([]);
  const [columns] = useState([
    {
      Header: 'Name',
      accessor: portal => portal,
      noTranslate: true,
      filter: {
        type: 'search',
        placeholder: 'Name...'
      },
      filterMethod: DataTable.filterByContaining(accessorValue => accessorValue.name),
      Cell: row => (
        <A
          href={`/analytics/${brandProfileId}/content_portals/${row.value.id}`}
          title={row.value.name}
        >
          <NoTranslate text={row.value.name} />
        </A>
      )
    }
  ]);

  const fetchData = async () =>
    setData(await get(`/api/v1/brand_profiles/${brandProfileId}/content_portals`));

  useEffect(() => {
    fetchData();
  }, []);

  // replace with "no content portals" note.
  if (!data.length) return null;

  return (
    <div className="content-wrapper-inner">
      <H1>Content portals</H1>
      <DataTable.Table data={data} columns={columns} recordNoun="content portals" />
    </div>
  );
};

ContentPortals.propTypes = {
  appData: PropTypes.string.isRequired
};

export default ContentPortals;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_portals/content_portals.jsx